/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement } from 'react';

export type Props = {
	stepId: string;
	path: string;
	children: ReactElement;
	moveNext?: () => void;
};

export const Step = ({ children, moveNext, stepId }: Props): ReactElement =>
	React.cloneElement(children, { moveNext, stepId, key: stepId });

Step.defaultProps = {};

export default Step;
